<template>

  <section id="hero" class="d-flex align-items-center">
      <div class="container">

        <div class="row">

          <div class="col-lg-5 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">

            <h1 class="pb-2" data-aos="fade-up">Vendeu, nós gerenciamos as notas fiscais por você</h1>

            <h5 class="pb-3" data-aos="fade-up" data-aos-delay="400">Integramos com sua plataforma de pagamento e emitimos suas notas fiscais de serviço.</h5>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> API de Integração Simples
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Ideal para Infoprodutores
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Ideal para escritórios de contabilidade
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Controle total das suas notas
            </div>

            <div class="col-lg-12 check-button" data-aos="fade-up" data-aos-delay="150">
              <a href="#planos" class="btn-get-started scrollto">Conheça nossos planos</a>
            </div>

          </div>

          <div class="col-lg-7 order-1 order-lg-2 hero-img" data-aos-delay="200">
            <img src="../assets/img/hero-sigame.png" class="img-fluid animated"  alt="">
          </div>

        </div>

      </div>
  </section>

</template>

<script>
export default {
  name: 'HeroComp'
}
</script>

<style scoped lang="scss">

#hero {
  background-color: $hero-bg-color;
  padding-top: 0;
  height: 98vh;
  padding: 25vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#hero h1 {
  margin: 0 0 10px 0;
  font-size: 45px;
  font-weight: 700;
  line-height: 50px;
  color: $color-base;
}

#hero .check-item {
  text-align: left;
}

#hero .check-button {
  padding-top: 10px;
}

#hero .btn-get-started {
  font-family: $font-family-base;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 30px;
  border-radius: 50px;
  transition: 0.5s;
  color: $btn-default-bg;
  border: 2px solid $btn-default-bg;
  margin: 30px 0 0 0;
  text-decoration: none;
}

#hero .btn-get-started:hover {
  background: $btn-default-bg-hover;
  color: $btn-default-color;
}

#hero .animated {
  animation: up-down 20s ease-in-out infinite alternate-reverse both;
}

@media (max-width: 991px) {
  #hero {
    height: 100vh;
    margin-top: 60px;
    padding-top: 85px;
  }
  #hero .animated {
    animation: none;
  }
  #hero .hero-img {
    text-align: center;
  }
  #hero .hero-img img {
    width: 50%;
  }
}

@media (max-width: 768px) {
  #hero {
    width: 100%;
    height: 100vh;
    margin-top: 100px;
    padding-top: 70px;
    margin-bottom: -80px;
  }
  #hero h1 {
    margin-top: -25px;
    font-size: 28px;
    line-height: 32px;
    text-align: center;
  }
  #hero h2 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }
  #hero h5 {
    text-align: center;
  }
  #hero .check-item {
    text-align: center;
  }

  #hero .hero-img img {
    width: 70%;
  }
  #hero .btn-get-started {
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 1px;
    display: inline-block;
    padding: 10px 30px;
    border-radius: 50px;
    transition: 0.5s;
    margin: 30px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 575px) {
  #hero {
    width: 100%;
    height: 100vh;
    margin-top: 100px;
    padding-top: 50px;
    margin-bottom: -80px;
  }
  #hero .hero-img img {
    width: 80%;
  }

  #hero .check-item {
    text-align: center;
  }
}

@keyframes up-down {
  0% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(-10px);
  }
}

</style>
